const request = (options) => {
  return new Promise((resolve, reject) => {
    let method = options.method;
    let url = options.url;
    let timeout = options.timeout;
    let data = options.data;
    let header = options.header;
    if (typeof wx !== 'undefined' && wx.request) {
      wx.request({
        method: method,
        url: url,
        timeout: timeout,
        data: data,
        header: header,
        success: (res) => {
          resolve(res);
        },
        fail: (err) => {
          reject(err);
        },
      });
    } else {
      let xhr = new XMLHttpRequest();
      xhr.timeout = timeout;
      xhr.open(method, url);
      xhr.withCredentials = (options.withCredentials ? true : false);
      for (let name in header) {
        if (name) {
          xhr.setRequestHeader(name, header[name]);
        }
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          // Get the raw header string
          let headers = xhr.getAllResponseHeaders();
          // Convert the header string into an array
          // of individual headers
          let arr = headers.trim().split(/[\r\n]+/);
          // Create a map of header names to values
          let headerMap = {};
          arr.forEach(function (line) {
            let parts = line.split(': ');
            let header = parts.shift();
            let value = parts.join(': ');
            headerMap[header] = value;
          });

          let res = {
            statusCode: xhr.status,
            header: headerMap,
            data: xhr.responseText,
          };
          if (xhr.status >= 200 && xhr.status < 400) {
            resolve(res);
          } else {
            reject(res);
          }
        }
      };
      xhr.send(JSON.stringify(data));
    }
  });
};
export default request;